<template>
  <div>
     <iframe  style="width:100%;height:500px" :src="this.url"  title="SoftlineAngola"></iframe>
  </div>
  </template>

<script>
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import impressaoService from '../../services/impressaoService'
import impressaoUtilitario from '../../utilitarios/impressao.utilitario'
const ls = require('local-storage')
export default {
  data: () => ({
    idCliente: ls.get('itemsFaturaEstaticos').cliente[0].idCliente,
    saldoEstudante: 0,
    resumoImposto:ls.get('resumoImposto'),
    lastInscricaoNaTurma: ls.get('lastMAtriculaOfStudent'),
    url: '',
    html: '',
    autor:ls.get('nomeUsuario'),
    total_recibo: '57 500,00 AOK',
    empresa: {
      director1: 'CUSTÓDIO ADOLFO CALEI',
      director2: 'SANDRA DAVID GONÇALVES'
    },
    itemsDaFactura: ls.get('itemsFatura'),
    infoFactura:ls.get('itemsFaturaEstaticos'),
    factura:
  {
    'factura_recibo': ls.get('itemsFaturaEstaticos').documento,
    'bolseiro': (ls.get('bolseiro').length) ? (ls.get('bolseiro')[0].ongBolsa + '-' + ls.get('bolseiro')[0].percentagem) : 'Não',
    'cliente': ls.get('itemsFaturaEstaticos').cliente[0].nome,
    'matricula': ls.get('itemsFaturaEstaticos').cliente[0].numero_matricula,
    'curso': ls.get('itemsFaturaEstaticos').cliente[0].descricao,
    'classe': ls.get('itemsFaturaEstaticos').cliente[0].classe_descricao,
    'items': ls.get('itemsFatura'),
    'total_pagar': ls.get('itemsFaturaEstaticos').valorApagar,
    'total_pago': ls.get('itemsFaturaEstaticos').valorPago,
    'troco': ls.get('itemsFaturaEstaticos').troco,
    'valorIliquido':ls.get('valorIliquido'),
    'dataPagamento': ls.get('itemsFaturaEstaticos').dataPagamentoSelected,
    'totalMulta': ls.get('totalMulta'),
    'autor': ls.get('itemsFaturaEstaticos').autor,
    'number_item': 1,
    'tiDQ': 'Documento Processado por programa validado',
    'utilizador': 'Pedro'
  },
    estudante:
  {
    'number_recibo': '001',
    'number_deposito': '0109',
    'nome_empresa': 'INSTITUTO  SUPERIOR POLITÉCNICO PRIVADO DO LUENA',
    'cliente': 'Alexandrina Francisco de Almeida',
    'curso': 'ENSINO PRIMÁRIO',
    'turma': 'EP3ºM1B',
    'matricula': '3333332-26'

  },
    font: {
      titulo: (window.location.host.includes('192.168.20.2')) ? '10px' : '10px',
      corpotexto: (window.location.host.includes('192.168.20.2')) ? '9px' : '8px'
    },
    mes_ano: '',
    data_actual: '',
    dataHora: '',
    hora: '',
    formatter: 0,
    config: null,
    baseUrl: ''
  }),
  async created () {
    console.log(ls.get('itemsFaturaEstaticos'))
    await this.pesquisarStatusSaldo()
    this.data_hora()
    this.config = impressaoUtilitario.getConfig()
    this.getUrlImpressao()
  },

  methods: {

    async pesquisarStatusSaldo () {
      try {
        let params = {
          idCliente: this.idCliente
        }

        let result = await axios.post('/ObterStatusSaldoAluno', params).then(res => res.data)
        if (result.saldo) {
          this.saldoEstudante = result.saldo
        } else {
          this.saldoEstudante = 0
        }
      } catch (error) {
        // console.log(error);
      }
    },

    async getUrlImpressao () {
      try {
        this.baseUrl = await impressaoService.getBaseUrl().then((res) => res.data[0].url)
      } catch (error) {
        console.log(error)
      } finally {
        this.comporHtml()
      }
    },

    data_hora () {
      let data = new Date()
      this.mes_ano = (data.getFullYear()) + (data.getMonth() + 1)
      this.data_actual = data.getDate() + '/' + (data.getMonth() + 1) + '/' + (data.getFullYear())
      this.hora = (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
      this.dataHora = data.getDate() + '-' + (data.getMonth() + 1) + '-' + (data.getFullYear()) + '  ' + (data.getHours()) + ':' + (data.getMinutes().toString().padStart(2, '0')) + ':' + (data.getSeconds())
    },
async comporHtml () {
        try {
            let heading = ` <td>
          <table class="heading2">
            <tr>
        <td><img height="50px" src="data:image/jpeg;base64,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"/></td>
        <td><span class="negrito">Factura/Recibo</span><br>`+this.factura.factura_recibo+`</td>
        </tr>
        <tr>
        <td class="negrito">Instituto Técnico Privado de Saúde Ilha da Verdade<br><span></span></td>
        <td><span class="negrito">Nome</span><br>`+this.factura.cliente+`</td>
      </tr>
      <tr>
        <td><span class="negrito">Capital Social:&nbsp;&nbsp;200 000,00</span>
        <br><span class="negrito" >Nº Contribuente:&nbsp;&nbsp;5417113387</span>
        <br><span class="negrito" >(t)</span> <span style="font-size:10px;">222788370</span>
        <br><span class="negrito" >(e)</span> <span style="font-size:10px;">secretaria.civ21@institutoilhadaverdade.com</span>
        <br><span  class="negrito">(w)</span> <span style="font-size:10px;">WWW.GRUPOILHADAVERDADE.COM</span>
        </td>
        <td> <span class="negrito" >Dados do Aluno</span>
          <br><span class="negrito" >Nº</span>`+this.factura.matricula+`
          <br>`+this.factura.cliente+`<br> `+this.ObterClasse(parseInt(this.lastInscricaoNaTurma.idano_academico))+` Ensino Técnico
          <br><span  class="negrito">Turma:</span> `+this.lastInscricaoNaTurma.turma+`
        </td>
    </tr>
        </table>
        </td>`
 
            let produtos = `<td>
      <table class="produto">
         <!-- ***************************************Cliente************************** -->
        <tr class="bordaTop">
           <td colspan="2">V/NºContribuente</td>
          <td class="centerText">Moeda</td>
          <td colspan="2" class="centerText">Data de Emissão</td>
          <td colspan="2" class="centerText">Data de Pagamento</td>
          <td class="centerText">Ano Lectivo</td>
        </tr>
        <tr class="bordaBottom sizeText">
          <td class="justifyText" colspan="2">Consumidor Final</td>
          <td class="centerText">AOA</td>
          <td colspan="2" class="centerText">`+utilitarios.returnDataCorrectFormat(utilitarios.ObterDataActural())+`</td>
          <td colspan="2" class="centerText">`+utilitarios.returnDataCorrectFormat(utilitarios.ObterDataActural())+`</td>
          <td class="centerText">`+ls.get('anolectivo')+`</td>
        </tr>
        <!-- ***************************************Produto************************** -->
        <tr class="bordaBottom">
          <td>Ref.</td>
          <td>Descricao</td>
          <td class="centerText">Qtd.</td>
          <td class="centerText">Pr. Unitário</td>
          <td class="centerText">Desc%</td>
          <td class="centerText">TX%</td>
          <td class="centerText">Cod. Ise.</td>
          <td class="centerText">Total</td>
        </tr>
        `
            let resumo = `` 
  let array1 = [{ref:1,descricao:'bata',qtd:1,precounitario:1000,desconto:0,taxa:'N/A',codIse:'N/A',total:'1000 kz'}]
  let array2 = [{descricao: '#######',taxa: '#######',incidencia: '#######',imposto: '#######'}]
  this.itemsDaFactura.forEach(element => {
    console.log(element)
    produtos += ` <tr><td style="font-size:10px;">` + element.fkProduto + `</td>
          <td class="justifyText" style="font-size:10px;">` + element.produto + `</td>
          <td class="centerText" style="font-size:10px;">` + element.qtd_venda + `</td>
          <td class="rightText" style="font-size:10px;">` + utilitarios.IntegerToMoneyValueFatura(element.precoUnitario) + `</td>
          <td class="centerText" style="font-size:10px;">` + element.descontoLinha + `</td>
          <td class="centerText" style="font-size:10px;"> 0,00</td>
          <td class="centerText" style="font-size:10px;">M21</td>
          <td class="rightText" style="font-size:10px;">` + utilitarios.IntegerToMoneyValueFatura(element.subTotal) + `</td></tr>`
  });
  this.resumoImposto.forEach(element => {
    resumo += `<tr>
          <td style="font-size:10px;">ISE nos termos da alínea l) do nº1 do artigo 12 º do CIVA</td>
          <td class="centerText" style="font-size:10px;">0</td>
          <td class="centerText" style="font-size:10px;"> ` + utilitarios.IntegerToMoneyValueFatura(element.totalIsento) + ` </td>
          <td class="centerText" style="font-size:10px;"> ` + utilitarios.IntegerToMoneyValueFatura(element.totalIva) + ` </td>
        </tr>`
  });
  let footer = `<td>
     
     <table class="resumoSizeText">
        <tr class="sizeText removerbold"><td colspan="4">uJIW-Processado por programa validado nº</td></tr>
        <tr><td colspan="4">Designação</td></tr>
       <tr>
         <td>Descrição do Pagamento:</td>
         <td colspan="3">`+this.infoFactura.pkVenda+`</td>
       </tr>
       <tr>
         <td>Local de Tesouraria:</td>
         <td style="font-size:8px;font-weight:normal;">`+this.infoFactura.tpaRef+`</td>
         <td class="rightText">Total Iliquido:</td>
         <td class="rightText">`+utilitarios.IntegerToMoneyValueFatura(this.infoFactura.valorIliquido)+`</td>
       </tr>
       <tr>
         <td>Modo de Pagamento:</td>
         <td style="font-size:8px;font-weight:normal;">`+this.infoFactura.tpaRef+`</td>
         <td class="rightText">Descontos Comerciais</td>
         <td class="rightText">0,00</td>
       </tr>
       <tr>
 <td>Total de Multas:</td>
 <td>0,00</td>
 <td class="rightText">Desconto Financeiro:</td>
 <td class="rightText">0,00</td>
 </tr>
 <tr>
 <td>Saldo usado:</td>
 <td>0,00</td>
 <td class="rightText">Total de Imposto:</td>
 <td class="rightText">0,00</td>
 </tr>
 <tr>
 <td>Saldo Actual:</td>
 <td>0,00</td>
 <td class="rightText">Total Recebido:</td>
 <td class="rightText">`+utilitarios.IntegerToMoneyValueFatura(this.infoFactura.valorAPagar)+`</td>
 </tr>
 <tr>
 <td colspan="2">Resumo:</td>
 <td class="rightText">Total do Documento:</td>
 <td class="rightText">`+utilitarios.IntegerToMoneyValueFatura(this.infoFactura.valorAPagar)+`</td>
 </tr>
 <tr>
   <td colspan="2">
     
<table class="resumo">
       <tr>
         <td>Descrição</td>
         <td>TX%</td>
         <td>Incidência</td>
         <td>Imposto</td>
       </tr>
       ` + resumo + `
     </table>
   </td>
    <td colspan="2"></td>
 </tr>
  <tr class="lineheight">
   <td colspan="2" class="removerbold">Emitido por `+this.infoFactura.autor+` | `+utilitarios.returnDataCorrectFormat(utilitarios.ObterDataActural())+` | `+utilitarios.ObterHoraActual()+`</td>
   <td rowspan="2" style="font-size:8px;" colspan="2" class="removerbold">Recebemos de V. Exa(s). a quantia de `+utilitarios.IntegerToMoneyValueFatura(this.infoFactura.valorAPagar)+`(`+utilitarios.ObterValorPorExtensao(this.infoFactura.valorAPagar)+`) através de Rec. em Multicaixa</td>
 </tr>
 <tr>
   <td colspan="2" class="removerbold">Imprenso por `+utilitarios.returnDataCorrectFormat(utilitarios.ObterDataActural())+`  | `+utilitarios.ObterHoraActual()+`</td>
 </tr>
     </table>
   </td>
`
  this.html = `<html>
        <head>
<style>
 table.heading {
      font-family: arial, sans-serif;
      border-collapse: collapse;
      width: 100%;
      font-size:12px;      
    }
    table.heading2 {
      font-family: arial, sans-serif;
      border-collapse: collapse;
      width: 100%;
      font-size:12px;
    }
    div.linhaVertical { border-left:1px solid #000;padding-left:8px;}
.heading td{ border: 0px solid #000;}
.heading1 td{ width:50%}
.heading2 td{ width:50%}
.negrito { font-weight:bold; }
tr.bordaTop { border-top: 1px solid #000;}
tr.bordaBottom  { border-bottom: 1px solid #000;}
tr.sizeText { font-size:10px;}
.justifyText { text-align:justify;}
.centerText { text-align:center;}
.rightText { text-align:right;}
tr.lineheight { line-height:50px;}
tr.lineheight2 { line-height:30px;}
table.produto {
      font-family: arial, sans-serif;
      border-collapse: collapse;
      width: 100%;
      font-size:12px;
    }

    table.resumo {
      font-family: arial, sans-serif;
      border-collapse: collapse;
      width: 100%;
      font-size:10px;
    }
    .resumo td{ border: 1px solid #000;}
    .resumoSizeText {font-size: 11px;line-height:15px;font-weight:bold;}
    .removerbold {font-weight:normal;font-size:8px;}
    .spacebetweenTables { margin-top:40px;}
</style>

        </head>
    <body>
        <table class="heading">
           <tr>
        ` + heading + `
        ` + heading + `
            </tr>
        </table>

        <table class="heading spacebetweenTables">
            <tr>
        ` + produtos + `
        <tr class="bordaTop sizeText"><td colspan="8">Os bens e/ou serviços prestados, foram colocados á disposição do adquirente na data e local do documento.</td></tr>
        </table>
        </td>
        ` + produtos + `
        <tr class="bordaTop sizeText"><td colspan="8">Os bens e/ou serviços prestados, foram colocados á disposição do adquirente na data e local do documento.</td></tr>
        </table>
        </td>
        </tr>
        </table>

        <table class="heading spacebetweenTables">
            <tr>
        ` + footer + `
        ` + footer + `
        </tr>
        </table>
       `
          let options = {
            'format': 'A4',
            'orientation': 'landscape',
            'border': { 'right': '5mm', 'left': '5mm' },
            'header': { 'height': '5mm' },
            'footer': { 'height': '5mm' }
          }
          this.gerarPDF(options)
        } catch (error) {
          console.log(error)
        }
      },
      async  gerarPDF (options) {
        this.isLoading = true
        try {
          await axios({
            method: 'post',
           // url: 'http://eftsl.softlineangola.com:8082/writefile',
           url: 'http://192.168.18.15:8085/writefile',
            data: {
              html: this.html,
              file_name: ls.get('nomeUsuario'),
              option: options
            }
          }).then()
          // Imprimir PDF
         this.frame()
        } catch (error) {
        }
      },

      ObterClasse (idanoacademico){
         switch(idanoacademico){
           case 1:
             return '10ª Classe'
          case 2:
             return '11ª Classe'
          case 3:
             return '12ª Classe'
          case 4:
             return '14ª Classe'
            
          default:
            return 'Inválido'
             
         }
      },
      frame () {
       let link = 'http://192.168.18.15:8085/readfile/'+ls.get('nomeUsuario')+'.pdf'
        let frame = `<html> +
        <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
        <body>
        <iframe target="_blank" type="application/pdf" src="` + link + `"></iframe> 
        </body></html>`
        let a = window.open('about:blank', '_blank', '', true)
        a.document.write(frame)
        a.document.close()
      },
  }
}

</script>

  <style scoped>
  .v-progress-circular {
    margin: 1rem;
  }
  .progressCircularIsMatriculaURL {
    margin: 1rem;

    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -50px;
    margin-left: -100px;

  }
  </style>
